import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';

import { EntryContext } from '../contexts/entryContext';
import InnerLayout from '../components/layouts/InnerLayout';
import TeleScript from '../utils/TeleScript';
import { useNavigate } from 'react-router-dom';

const Policy = () => {
    const { siteAssets } = useContext(EntryContext);

    // Redirect to home page when the feature is disabled
    const navigate = useNavigate();

    useEffect(() => {
        if (!siteAssets?.features?.privacyPolicyPageEnabled) {
            return navigate('/games', { replace: true });
        }
    }, [navigate, siteAssets?.features?.privacyPolicyPageEnabled]);

    return (
        <InnerLayout>
            <Helmet>
                <title>
                    {siteAssets?.privacyPageTitle ?? 'Privacy Policy'} - {siteAssets?.title ?? 'Scratch Connect'}
                </title>
            </Helmet>
            <div className='policy-page'>
                <div className='policy-text'>
                    <TeleScript line={siteAssets?.contentHTML?.privacyPolicy}>Privacy Policy content</TeleScript>
                </div>
            </div>
        </InnerLayout>
    );
};

export default Policy;
